import * as React from 'react';
import { styled } from '@linaria/react';

import Demo from '@/components/Demo';
import Paper from '@/components/Paper';
import ArrowShowingDistance from '@/components/ArrowShowingDistance';
import SliderControl from '@/components/Controls/SliderControl';

const SENTENCE =
  'Hello world! This is a sentence that includes several different words, but contains no real meaning.';

function FitContentDemo() {
  const ref = React.useRef<HTMLDivElement>(null);

  const [numOfCharacters, setNumOfCharacters] = React.useState(12);
  const [arrowWidth, setArrowWidth] = React.useState<number | null>(
    null
  );

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    const boundingBox = ref.current.getBoundingClientRect();

    setArrowWidth(boundingBox.width);
  }, [numOfCharacters]);

  return (
    <Demo
      initialValues={{}}
      outputWrapper={OutputWrapper}
      controlPosition="top"
      customGrid={{
        gridTemplateColumns: `min(500px, 100%) !important`,
        justifyContent: 'center',
      }}
      renderAltControls={() => (
        <SliderWrapper>
          <SliderControl
            id="numOfCharacters"
            key="numOfCharacters"
            name="numOfCharacters"
            label="Num of Characters"
            value={numOfCharacters}
            setValue={setNumOfCharacters}
            min={5}
            max={100}
          />
        </SliderWrapper>
      )}
    >
      {() => {
        const boldCharacters = SENTENCE.slice(
          0,
          Math.min(12, numOfCharacters)
        );
        const remainingCharacters = SENTENCE.slice(
          12,
          Math.max(12, numOfCharacters)
        );

        return (
          <Wrapper>
            {typeof arrowWidth === 'number' && arrowWidth > 5 && (
              <ArrowWrapper>
                <ArrowShowingDistance
                  animateTransitions="label-only"
                  axis="horizontal"
                  unit="rem"
                  distance={arrowWidth + 4}
                  flipTextSide
                />
              </ArrowWrapper>
            )}
            <Sentence ref={ref}>
              <strong>
                {boldCharacters}
                {boldCharacters[boldCharacters.length - 1] === ' ' &&
                  '​'}
              </strong>
              {remainingCharacters}
              {remainingCharacters[remainingCharacters.length - 1] ===
                ' ' && '​'}
            </Sentence>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const OutputWrapper = styled(Paper)`
  position: relative;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--padding);
  text-align: center;
  overflow: hidden;
  border-radius: 4px;
`;

const SliderWrapper = styled.div`
  width: 360px;
  max-width: 100%;
  margin-inline: auto;
`;

const Wrapper = styled.div`
  position: relative;
`;

const Sentence = styled.div`
  display: block;
  width: fit-content;
  outline: solid var(--color-secondary);
  border-radius: 2px;
`;

const ArrowWrapper = styled.div`
  position: absolute;
  transform: translate(-2px, -100%);
  top: -4px;
  left: 0;
  right: 0;
  margin-inline: auto;
`;

export default FitContentDemo;
